import { combineReducers } from "redux";
import { apiReducer } from '../../utils/api/reducer';
import { Constants } from './constants';

export const selectedPlayers = (state = { side1: [], side2: [] }, action: any) => {
  switch (action.type) {
    case Constants.SET_SIDE_ONE:
      return {
        ...state,
        side1: action.payload,
      };
    case Constants.SET_SIDE_TWO:
      return {
        ...state,
        side2: action.payload,
      };
    default:
      return state;
  }
};

export const playerCompareReducer = combineReducers({
  players: apiReducer(Constants.SET_PLAYER),
  selectedPlayers,
  compareResults: apiReducer(Constants.SET_RESULTS),
  authenticated: apiReducer(Constants.SET_AUTH),
  config: apiReducer(Constants.GET_CONFIG),
});